import { Progress } from "@chakra-ui/react";
import Education from "../../../components/candidate/signupFlow/education";
import { getisProfile30percent } from "../../../utils/helper";

const EducationPage = () => {
  const profilePercentage = getisProfile30percent();
  return (
    <>
      <Progress
        colorScheme="progressBar"
        size="xs"
        value={profilePercentage}
        w="full"
        borderRadius={"lg"}
        mb="6 !important"
        mt="2 !important"
      />
      <Education />
    </>
  );
};

export default EducationPage;
